import React from "react";

const NotFoundPage = () => {
  return(
    <h1>Error 404: Page not Found</h1>
  );
};

export default NotFoundPage;
